define('app/views/tab_view',['app/setup','app/views/tab_view'], function(takhfifan,tabView) {

  takhfifan.TabView = Backbone.View.extend({
    el: $('.tabs'),

    events: {
      'click .tab-nav a': 'change_tab'
    },

    initialize: function() {
      var _this = this;
      var hash = window.location.hash;

      if (hash == "") {
        if(!_.isUndefined(this.$el.data('default'))) {
          hash = this.$el.data('default');
        }
        else {
          hash = '#' + $(".tab-cnt").first().attr('id');
        }
      }

      takhfifan.eventHub.on('tab:show', function(data) {
        _this.show(data);
      }, this);


      takhfifan.eventHub.trigger('tab:show', { id: hash });

      $(window).bind('hashchange', function(){
        var hash = window.location.hash;
        takhfifan.eventHub.trigger('tab:show', { id: hash });
      });
    },

    show: function(options) {
      if(!options.id.length=="0") {
        if(!this.$el.hasClass('checkout')) {
          //workaround : utf-8 codes in url hash
          var rawId = options.id.replace("#","");
          if(rawId !== encodeURIComponent(rawId)){return}

        var target = $(options.id);
        var tab_id = $(target).attr('id');
        var cnt_id = $(target).data('tab');

        var tagAnchor = $('*[data-tab="' + tab_id + '"]').first();
        this.$('.tab-nav .active').removeClass('active');
        $(".tab-cnt").removeClass("active");

        $(target).addClass("active");
        $('#' + cnt_id).addClass("active");
        tagAnchor.parent().addClass("active");
        }
      }
    },

    change_tab: function(e){
      if(!$(e.currentTarget).parent().hasClass('tkh-link')) {
        var tab_id = '#' + $(e.currentTarget).data('tab');
        window.location.hash =  tab_id;
      }
    }
  });
});

